import {Auditable} from "./auditable.model";
import {Customer} from "./customer.model";

export class Tenant extends Auditable {
  tenantId: number;
  name: string;
  customer: Customer;

  constructor(tenant?: Tenant) {
    super(tenant);
  }

  setProperties(tenant: Tenant) {
    super.setProperties(tenant);
    this.customer = new Customer(tenant.customer);
  }
}
